import { invokeApi } from "../../../bl_libs/invokeApi";

export const _close_invoice = async (postData, shipment_id) => {
  const requestObj = {
    path: `api/shipment/close_invoice/${shipment_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: postData,
  };
  return invokeApi(requestObj);
};
